module.exports = __webpack_public_path__ + "static/media/logo-uber.8a55a3a9.svg";